import { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { BD, SEVERIDADE, StatusBadge } from '../styles'

export type DestaqueCartao = boolean | 'atencao' | 'critico'

const bordaDoDestaque = (d?: DestaqueCartao): string =>
  d === 'critico' ? SEVERIDADE.critico.borda : d ? SEVERIDADE.atencao.borda : BD.grayBorder

const Caixa = styled(Link)<{ $destaque?: DestaqueCartao; $esmaecido?: boolean }>`
  display: block;
  padding: 14px;
  background: #fff;
  border: 1px solid ${({ $destaque }) => bordaDoDestaque($destaque)};
  border-radius: 12px;
  color: ${BD.black};
  text-decoration: none;
  opacity: ${({ $esmaecido }) => ($esmaecido ? 0.72 : 1)};
`

const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Codigo = styled.span`
  flex-grow: 1;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
  color: ${BD.grayText};
`

const Titulo = styled.div`
  margin-top: 6px;
  font-size: 16px;
  font-weight: 600;
`

const Meta = styled.div`
  margin-top: 2px;
  font-size: 13px;
  color: ${BD.grayText};
`

const Rodape = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid ${BD.grayBorder};
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
`

const RodapeInicio = styled.span`
  flex-grow: 1;
  min-width: 0;
`

const RodapeFim = styled.span`
  flex-shrink: 0;
  font-size: 12px;
  color: ${BD.grayText};
`

export interface BadgeCartao {
  bg: string
  color: string
  label: string
}

export interface CartaoProps {
  to: string
  codigo: string
  titulo: ReactNode
  badge?: BadgeCartao
  meta?: ReactNode
  rodape?: ReactNode
  rodapeFim?: ReactNode
  destaque?: DestaqueCartao
  esmaecido?: boolean
}

/**
 * OP-3619 — a linha da tabela no celular.
 *
 * Guarda o que decide se alguém abre o registro: quem é (código e nome),
 * em que pé está (badge) e o que vence ou falta (rodapé). O resto é detalhe
 * e mora na tela do registro.
 */
export const Cartao: FC<CartaoProps> = ({
  to, codigo, titulo, badge, meta, rodape, rodapeFim, destaque, esmaecido,
}) => (
  <Caixa to={to} $destaque={destaque} $esmaecido={esmaecido}>
    <Topo>
      <Codigo>{codigo}</Codigo>
      {badge && <StatusBadge $bg={badge.bg} $color={badge.color}>{badge.label}</StatusBadge>}
    </Topo>
    <Titulo>{titulo}</Titulo>
    {meta && <Meta>{meta}</Meta>}
    {(rodape || rodapeFim) && (
      <Rodape>
        <RodapeInicio>{rodape}</RodapeInicio>
        {rodapeFim && <RodapeFim>{rodapeFim}</RodapeFim>}
      </Rodape>
    )}
  </Caixa>
)

export default Cartao
